<template>

    <div class="row">
        <div class="col-md-12">
            <div class="form-group">
                <label for="name">Nama Satuan </label>
                <input type="text" v-model="model.name" class="form-control" readonly>
            </div>
        </div>
    </div>

</template>

<script>
export default {
    components: {},
    props: {
        detail: {
            type: Object,
            default: () => ({
                name: '',
                id: '',
            })
        }
    },
    data() {
        return {
            model: {
                name: this.detail?.name,
                id: this.detail?.id,
            }
        }
    },
    methods: {
        resetModel() {
            this.model = { name: '', id: '', }
        }
    },
    watch: {
        detail: {
            immediate: true,
            deep: true,
            handler(newVal) {
                this.model = {
                    name: newVal?.name || '',
                    id: newVal?.id || '',
                }
            }
        }
    }
}
</script>